import React from "react";
import {
  applicantRelationshipBadgeClass,
  resolveApplicantRelationship,
  type ApplicantRelationshipFlags,
  type ApplicantRelationshipKind,
} from "../utils/hospitalDisplayUtils";

type Props = {
  applicant: ApplicantRelationshipFlags;
  className?: string;
};

export default function ApplicantRelationshipBadge({
  applicant,
  className = "",
}: Props) {
  const relationship = resolveApplicantRelationship(applicant);
  if (relationship.kind === "NEW") return null;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold tracking-wide ${applicantRelationshipBadgeClass(relationship.kind)} ${className}`}
    >
      {relationship.label}
    </span>
  );
}

export function relationshipKindOf(
  applicant: ApplicantRelationshipFlags,
): ApplicantRelationshipKind {
  return resolveApplicantRelationship(applicant).kind;
}
